<template>
    <div>
        <v-data-table
            :headers="table.content.headers.filter((item)=> item.value !== 'id')"
            :items="table.content.body"
            :pagination.sync="pagination"
            item-key="id"
            :search="table.content.search"
            sort-icon="keyboard_arrow_down"
            class="table-list"
            hide-actions
        >
            <template slot-scope="props" slot="headers">
                <tr>
                    <template
                        v-for="header in props.headers"
                    >
                        <th :key="header.text"
                            :class="['column sortable', table.content.pagination.descending ? 'desc' : 'asc',
                                     header.value === table.content.pagination.sortBy ? 'active' : '']"
                            height="60px"
                            @click="changeSort(header.value)"
                        >
                            {{ $t(header.text) }}
                            <v-icon small aria-hidden="true" translate="no">keyboard_arrow_up</v-icon>
                        </th>
                    </template>
                </tr>
            </template>
            <template slot-scope="props" slot="items">
                <tr :class="{'active-name-field': +props.item.id === user.id || +props.item.id === user.company_id }" @click="open_accepting(props)">
                    <td v-for="(i, key) in props.item"
                        v-if="!(['id', 'external', 'active', 'specialization'].indexOf(key) !== -1)"
                        :key="'i'+key" class="text-xs-left px-2"
                    >
                        <a class="link link--no-decor default-text" @click='handleClickLick(link, key, i, $event)'>
                            <v-layout v-if="i && typeof i == 'object'" class="align-center">
                                <div :style="`background-image: url(${(i[0]) ? url + i[0] : (i[1] === null) ? '' : (type === 'organizations') ? 'icons/organization.svg' : 'icons/courses.svg'})`"
                                     alt="avatar"
                                     class="mr-2 table-avatar"
                                     :class="{'table-progress': key === 'achievement', 'bg-cover': type === 'employees' && key === 'name' }"
                                ></div>
                                <div :class="{'name-field': key === 'name'}">{{ key === 'achievement' ? $t(i[1]) : i[1] }}</div>
                            </v-layout>
                            <div v-if="key == 'date' && typeof i != 'string'" class="px-4">{{ get_date(i) }}</div>
                            <div v-if="typeof i == 'string'" class="px-4">{{ ['type', 'request_type', 'level'].includes(key) ? $t(i) : i }}</div>
                        </a>
                    </td>
                </tr>
            </template>
            <div v-if="table.content.search!=''" slot="no-results" :value="true"
                 color="error" icon="warning" class="body-2"
            >
                {{ $t('По запросу ничего не найдено.') }}
            </div>
            <div slot="no-data" :value="true" color="error"
                 icon="warning" class="body-2"
            >
                {{ $t("По запросу ничего не найдено.") }}
            </div>
        </v-data-table>
    </div>
</template>

<script>
import acceptRequestModal from './Users_modals/Accept_request';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);
export default {
  components: {
    acceptRequestModal,
  },
  props: {
    table: {
      type    : Object,
      required: true,
    },
    type: {
      type: String,
    },
    link: {
      type   : String,
      default: '',
    },
    filter: {
      type: Object,
    },
  },
  computed: {
    ...mapState('common', [
      'url',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('users/modals', [
      'accept_request',
    ]),
    ...mapGetters('users/employees', [
      'users_employees_table',
    ]),
    ...mapGetters('users/organizations', [
      'users_organizations_table',
    ]),
    pagination: {
      get() {
        return this.table.content.pagination;
      },
      set($event) {
        if (this.type =='employees') {
          return this.SET_EMPLOYEES_PAGINATION($event);
        } else if (this.type=='organizations') {
          return this.SET_ORGANIZATION_PAGINATION($event);
        } else if (this.type=='user_requests') {
          return this.SET_REQUESTS_PAGINATION({pagination: $event, type: 'user'});
        } else if (this.type=='org_requests') {
          return this.SET_REQUESTS_PAGINATION({pagination: $event, type: 'org'});
        }
      },
    },
  },
  methods: {
    get_date(date) {
      return new dayjs(parseInt(date)).format('DD.MM.YYYY HH:mm:ss');
    },
    handleClickLick(link, option, value, event) {
      if (option === 'initiator') {
        event.stopPropagation();
        let initiator = this.table.content.body.find((item) => item.initiator === value);
        let initiatorId = initiator.request_by_id;
        if (initiatorId) {
          this.$router.push({name: 'profile_other', params: {id: initiatorId}});
        }
      } else {
        this.$router.push(link ? {name: link} : '');
      }
    },
    ...mapMutations('users/employees', [
      'SET_EMPLOYEES_PAGINATION',
      'CHANGE_EMPLOYEES_SORT',
    ]),
    ...mapMutations('users/organizations', [
      'SET_ORGANIZATION_PAGINATION',
      'CHANGE_ORGANIZATION_SORT',
    ]),
    ...mapMutations('users/requests', [
      'SET_REQUESTS_PAGINATION',
      'CHANGE_REQUESTS_SORT',
      'SET_REQUEST_ID',
      'SET_REQUEST_TYPE',
    ]),
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
    ...mapActions('users/employees', [
      'get_users',
    ]),
    ...mapActions('users/organizations', [
      'get_companies',
    ]),
    ...mapActions('users/requests', [
      'get_users_requests',
    ]),
    changeSort(column) {
      if (this.type=='employees') {
        this.CHANGE_EMPLOYEES_SORT(column);
        return this.get_users(this.filter);
      } else if (this.type=='organizations') {
        this.CHANGE_ORGANIZATION_SORT(column);
        return this.get_companies(this.filter);
      } else if (this.type=='user_requests') {
        this.CHANGE_REQUESTS_SORT({sort: column, type: 'user'});
        return this.get_users_requests(this.filter);
      } else if (this.type=='org_requests') {
        return this.CHANGE_REQUESTS_SORT({sort: column, type: 'org'});
      }
    },
    open_accepting(props) {
      if (this.type=='user_requests' || this.type=='org_requests' && this.user.role.user_managment.rights.includes('C')) {
        this.SET_REQUEST_ID(props.item.id);
        this.SET_REQUEST_TYPE(props.item.request_type);
        this.OPEN_MODAL('accept_request');
      } else if (this.type=='employees') {
        this.$router.push({name: 'profile_other', params: {id: props.item.id}});
      } else if (this.type=='organizations') {
        this.$router.push({name: 'company_other', params: {id: props.item.id || this.user.company_id}});
      }
    },
  },
};
</script>
